import { AxiosResponse } from 'axios';

import { axiosInstance } from '../api/axios-instance';
import { FileMetadataDto } from '../dtos/file-metadata.dto';
import { FileMetadataTypesEnum } from '../enums/file-metadata-types.enum';
import { ApkInfoModel } from '../models/apk-info.model';
import { createFileFormData } from './create-file-form-data/create-file-form-data.util';

export const sendFile = async (
  file: File,
  fileType: FileMetadataTypesEnum,
  path: string,
  apkInfo: ApkInfoModel | null = null,
  chunk: ArrayBuffer | null = null
): Promise<AxiosResponse<FileMetadataDto>> => {
  const formData = createFileFormData(file, fileType, chunk, apkInfo);

  return await axiosInstance.post(path, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
